// FILE: src/services/auth.js
import api from '../api/axios';

export default {

    
    async login(credentials) {
        const response = await api.post('/login', credentials);
        const { access_token, user } = response.data;
        if (access_token) {
            localStorage.setItem('auth_token', access_token);
            localStorage.setItem('user', JSON.stringify(user));
        }
        return response.data;
    },

    logout() {
        // لا نحتاج لطلب API للخروج إذا كان التوكن يحذف من طرف العميل فقط
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
    },

    getUser() {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    },

    isAuthenticated() {
        return !!localStorage.getItem('auth_token');
    }
}; 